import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import {
  CanonDetailsData,
  CustomVendorReportingOverviewList,
  CustomVendorReportingSearchFilters,
  ManufacturerMappingList,
  VendorReportTransferData,
  VendorReportingDetailData,
  VendorReportingDetailResponse,
  VendorReportingDetailResultsData,
  CustomRioDataEvaluationOverviewList,
} from './custom-vendor-reporting.models';
import { Branch, BranchesList } from 'src/app/organization/uig-branches/uig-branches.models';

@Injectable()
export class CustomVendorReportingAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  getVendorReporting(
    searchFilters: CustomVendorReportingSearchFilters
  ): Observable<CustomVendorReportingOverviewList> {
    return this.http.post<CustomVendorReportingOverviewList>(
      this.occEndpoints.buildUrl('customVendorReportingOverview'),
      searchFilters
    );
  }

  getManufacturerMappingList(): Observable<ManufacturerMappingList> {
    return this.http.get<ManufacturerMappingList>(
      this.occEndpoints.buildUrl('manufacturerMappingList')
    );
  }

  getBranchesList(): Observable<BranchesList> {
    return this.http.get<BranchesList>(
      this.occEndpoints.buildUrl('branchesList')
    );
  }

  getVendorReportingDetails(
    reportTransferData: VendorReportTransferData,
  ): Observable<VendorReportingDetailResponse> {
    const params = {
      manufacturer: reportTransferData.manufacturer,
      reportType: reportTransferData.reportTransferType,
      reportPeriod: reportTransferData.reportTransferPeriod,
      b2bUnit: reportTransferData.b2bUnit,
      country: reportTransferData.reportCountry,
      channel: reportTransferData.reportChannel,
    };
    return this.http.get<VendorReportingDetailResponse>(
      this.occEndpoints.buildUrl('customCanonVendorReportingDetails', {
        queryParams: params,
      })
    );
  }

  updateVendorReportDetailsData(
    reportTransferData: VendorReportTransferData,
    detailData: VendorReportingDetailData[]
  ): Observable<VendorReportingDetailResultsData[]> {
    const params = {
      manufacturer: reportTransferData.manufacturer,
      reportType: reportTransferData.reportTransferType,
      reportPeriod: reportTransferData.reportTransferPeriod,
      b2bUnit: reportTransferData.b2bUnit,
      country: reportTransferData.reportCountry,
      channel: reportTransferData.reportChannel,
    };
    return this.http.post<VendorReportingDetailResultsData[]>(
      this.occEndpoints.buildUrl('customCanonVendorReportingDetailsUpdate'),
      detailData,
      { params: params }
    );
  }

  deleteVendorReportDetailsData(
    reportTransferData: VendorReportTransferData,
    detailData: VendorReportingDetailData[]
  ): Observable<VendorReportingDetailResultsData[]> {
    const params = {
      manufacturer: reportTransferData.manufacturer,
      reportType: reportTransferData.reportTransferType,
      reportPeriod: reportTransferData.reportTransferPeriod,
      b2bUnit: reportTransferData.b2bUnit,
      country: reportTransferData.reportCountry,
      channel: reportTransferData.reportChannel,
    };
    return this.http.delete<VendorReportingDetailResultsData[]>(
      this.occEndpoints.buildUrl('customCanonVendorReportingDetailsDelete'),
      { body: detailData, params: params }
    );
  }

  uploadVendorReportDetailsFile(file: File): Observable<VendorReportingDetailResultsData[]> {
    var formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const url = this.occEndpoints.buildUrl('customVendorReportingDetailsCSVUpload');
    return this.http.post<VendorReportingDetailResultsData[]>(url, formData);
  }

  getRioDataEvaluationOverviewData(
    searchFilters: CustomVendorReportingSearchFilters
  ): Observable<CustomRioDataEvaluationOverviewList> {
    return this.http.post<CustomRioDataEvaluationOverviewList>(
      this.occEndpoints.buildUrl('customRioVendorReportingOverview'),
      searchFilters
    );
  }
}
